"use client";

import type Visit from "@packages/types/visit";

import { VISIT_COOKIE_MAX_AGE, VISIT_COOKIE_NAME } from "@shared/constants";

import { trackingCookieOptions } from "@shared/cookieConfigs";
import { throwUndefinedVariable } from "@shared/functions/throwError";
import Cookies from "js-cookie";

export default function createVisitCookie(props: Visit.Cookie) {
  if (!VISIT_COOKIE_MAX_AGE) {
    throwUndefinedVariable("VISIT_COOKIE_MAX_AGE");
  }

  if (!VISIT_COOKIE_NAME) {
    throwUndefinedVariable("VISIT_COOKIE_NAME");
  }

  Cookies.set(VISIT_COOKIE_NAME, JSON.stringify(props), {
    expires: VISIT_COOKIE_MAX_AGE / 86400,
    ...(trackingCookieOptions as Cookies.CookieAttributes),
  });
}
